import Layout from '../views/layout/Layout'

export default {
  path: '/producer',
  component: Layout,
  redirect: 'noredirect',
  name: 'producer',
  meta: {
    title: '素材制作工具',
    elicon: 'el-icon-fa-wrench',
    roles: [],
  },
  children: [
    // 视频自动化处理不需要权限控制，所以 me 接口都会返回 video.processor 这个 key
    {
      path: 'automation',
      name: 'producer.automation',
      component: () => import('@/views/automation/index'),
      meta: {
        title: '素材自动化处理',
        roles: ['video.processor'],
      },
    },
    {
      path: 'video-template',
      name: 'producer.video-template',
      component: () => import('@/views/producer/video-template/index.vue'),
      meta: {
        title: '视频模板库',
        roles: ['veditor.template.list'],
      },
    },
    // 试玩模板管理
    {
      path: 'template-management',
      name: 'producer.template-management',
      redirect: 'template-management/library',
      component: () => import('@/views/producer/common-template'),
      meta: {
        title: '试玩模板管理',
        roles: [], // 如果有子路由 roles，roles 必须配置为空数组
      },
      hiddenChildren: true,
      children: [
        {
          path: 'library',
          name: 'producer.template-management.library',
          component: () =>
            import('@/views/producer/common-template/templateLibrary'),
          meta: {
            title: '模板库',
            roles: ['gmaker.template.list'],
          },
        },
        {
          path: 'customTemplate',
          name: 'producer.template-management.customTemplate',
          component: () =>
            import('@/views/producer/common-template/customTemplate'),
          meta: {
            title: '客户制作模板',
            roles: ['gmaker.template.list'],
          },
        },
        {
          path: 'proxyTemplate',
          name: 'producer.template-management.proxyTemplate',
          component: () =>
            import('@/views/producer/common-template/templateLibrary'),
          meta: {
            title: '代制作模板',
            roles: ['gmaker.template.list'],
          },
        },
      ],
    },
    // 视频工具授权
    // {
    //   path: 'ics-authorization',
    //   name: 'producer.ics-authorization',
    //   component: () => import('@/views/producer/ics-authorization/index.vue'),
    //   meta: {
    //     title: '视频工具授权',
    //     roles: ['video.processor'],
    //   },
    // },
    {
      path: 'demo-management',
      name: 'producer.demo-management',
      redirect: { name: 'producer.demo-management.list' },
      component: () => import('@/views/producer/project-demo/index.vue'),
      meta: {
        title: '项目demo管理',
        roles: [], // 如果有子路由 roles，roles 必须配置为空数组
      },
      hiddenChildren: true,
      children: [
        {
          path: 'list',
          name: 'producer.demo-management.list',
          component: () =>
            import('@/views/producer/project-demo/project-demo.vue'),
          meta: {
            title: '试玩项目',
            roles: ['demo.project.list'],
          },
        },
        {
          path: 'video-list',
          name: 'producer.demo-management.video-list',
          component: () =>
            import('@/views/producer/project-demo/video-demo.vue'),
          meta: {
            title: '视频项目',
            roles: ['demo.project.list'],
          },
        },
      ],
    },
  ],
}
